import React, { useEffect, useCallback } from 'react';
import mixpanel from "mixpanel-browser";
import 'survey-core/defaultV2.min.css';
import { PlainLight } from "survey-core/themes/plain-light";


import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';

interface HeadacheSurveyProps {
  survey: any,
  userId: number,
  surveyName: string,
  showProgressBar?: string,
}

const HeadacheSurvey = (props: HeadacheSurveyProps) => {
  const { survey, userId, showProgressBar, surveyName } = props;

  const modelAttributes = {
    ...survey,
    showProgressBar,
    progressBarType: "pages",
    progressBarShowPageNumbers: false,
    progressBarShowPageTitles: false,
  }
  const model = new Model(modelAttributes);
  model.applyTheme(PlainLight);

  const surveyComplete = useCallback(async (survey) => {
    mixpanel.track(`Submit ${surveyName} Survey`);
    const response = await saveSurveyResults(
      "survey_results",
      survey.data,
      userId,
      surveyName,
    )
    const surveyResultId = response.survey_id;
    if (surveyResultId) {
      mixpanel.track(`Redirect to ${surveyName} Survey Result`);
      window.location.assign(`survey_results/${surveyResultId}${isDebugSurvey() ? "?debug=true" : ""}`);
    } else {
      window.location.assign(`survey/${surveyResultId}${isDebugSurvey() ? "?debug=true" : ""}`);
    }
  }, []);

  const pageChange = useCallback(async (_, options) => {
    const { propertyHash } = options.page;
    mixpanel.track(`Show ${surveyName} Survey page ${propertyHash.num}`);
  }, []);

  model.onComplete.add(surveyComplete);
  model.onAfterRenderPage.add(pageChange);

  useEffect(() => {
    mixpanel.identify(userId)
    mixpanel.track(`Start ${surveyName} Survey`);
  }, []);

  return (
    <>
      <Survey model={model} />
    </>
  );
};

export default HeadacheSurvey;

function isDebugSurvey() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const debug = urlParams.get('debug');
  return debug === "true";
}

async function saveSurveyResults(url, json, userId, surveyName) {
  try {
    const result = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify({ data: { data: json, user_id: userId, survey_name: surveyName } })
    })
    const data = await result.json();
    return data;
  } catch (error) {
    return error;
  }
}